import { useQuery } from "@tanstack/react-query";
import { getPaabud } from "@/api/paabud";
import type { PaabudDetailModel } from "@/interfaces/paabud";
import { INJUNCTIONS_QUERY_KEY } from "./useInjunctions";

export const createInjunctionQueryKey = (injunctionId: string) =>
  [...INJUNCTIONS_QUERY_KEY, injunctionId] as const;

export const useInjunction = (injunctionId: string) => {
  return useQuery<PaabudDetailModel>({
    enabled: injunctionId.length > 0,
    queryKey: createInjunctionQueryKey(injunctionId),
    queryFn: () => getPaabud(injunctionId),
    staleTime: 5 * 60 * 1000,
  });
};
